import Cookies from "js-cookie";
const auth_service = require("../helpers/authService");

const cookieOptions = { domain: process.env.REACT_APP_DOMAIN };

export const useRefreshToken = () => {
  const refresh = async () => {
    try {
      const raw = Cookies.get(process.env.REACT_APP_COOKIE_KEY);
      const jwt = raw ? JSON.parse(raw) : null;

      if (!jwt || !jwt.TokenType || !jwt.refreshToken) {
        Cookies.remove(process.env.REACT_APP_COOKIE_KEY, cookieOptions);
        window.location.href = process.env.REACT_APP_REDIRECT_ENDPOINT;
        return;
      }

      auth_service
        .getDataAuth("/usr/refresh", jwt.TokenType, jwt.refreshToken)
        .then((data) => {
          Cookies.remove(process.env.REACT_APP_COOKIE_KEY, cookieOptions);
          Cookies.set(
            process.env.REACT_APP_COOKIE_KEY,
            JSON.stringify({
              TokenType: data.data.TokenType,
              accessToken: data.data.AccessToken,
              refreshToken: jwt.refreshToken,
            }),
            cookieOptions
          );
        })
        .catch((err) => {
          Cookies.remove(process.env.REACT_APP_COOKIE_KEY, cookieOptions);
          console.log(err);
          window.location.href = process.env.REACT_APP_REDIRECT_ENDPOINT;
        });
    } catch (error) {
      Cookies.remove(process.env.REACT_APP_COOKIE_KEY, cookieOptions);
      console.log(error);
      window.location.href = process.env.REACT_APP_REDIRECT_ENDPOINT;
    }
  };
  return refresh;
};

export default useRefreshToken;
